import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//components
import AuthMain from "../AuthMain";
import OTPInput from "components/shared/OTPField";
import { Input } from "components/shared/Input";

//Utils
import { toPersian } from "utils/tools";

//contexts
import { UserContext } from "state/user/userContext";
import { GlobalContext } from "state/global/globalContext";

//Request
import { request } from "utils/request";

//Style
import styles from "./style.module.scss";

let timer;
const resendTime = 59;

const Login = () => {
    //satate
    const [OTP, setOTP] = useState("");
    const [remainTime, setRemainTime] = useState(resendTime);
    const [showResend, setResend] = useState(false);
    const [forgetPassword, setForgetPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    //const
    const history = useHistory();
    const OTPValid = OTP.length && OTP.length === 5;
    //use context
    const { state, dispatch } = useContext(UserContext);
    const { setErrorRecived, setLoading } = useContext(GlobalContext);
    console.log(state);
    const sendOTP = () => {
        if (!!OTPValid) {
            setLoading(true);
            request
                .post(
                    "/api/users/activation.json",
                    JSON.stringify({
                        mobile: state.phoneNumber,
                        activationCode: OTP,
                    }),
                )
                .then((res) => {
                    setLoading(false);
                    if (res?.data.state && res?.data.token) {
                        dispatch({
                            type: "setUserData",
                            payload: res?.data,
                        });
                        // setOTPState(OTP);
                        history.push("/dashboard");
                    } else if (res?.data.state) {
                        history.push("/login");
                    } else {
                        setErrorRecived(res?.data.message);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setErrorRecived("لطفا چند لحظه دیگر مجدد تلاش کنید");
                });
        } else {
            setErrorRecived("لطفا کد ارسال شده را به صورت صحیح وارد کنید");
        }
    };

    const recoverPassword = () => {
        if (!!OTPValid && password.length >= 6) {
            setLoading(true);
            request
                .post(
                    "/api/users/recoveryPassword.json",
                    JSON.stringify({
                        mobile: state.phoneNumber,
                        activationCode: OTP,
                        password,
                    }),
                )
                .then((res) => {
                    setLoading(false);
                    if (res?.data.state) {
                        history.push("/login");
                    } else {
                        setErrorRecived(res?.data.message);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setErrorRecived("لطفا چند لحظه دیگر مجدد تلاش کنید");
                });
        } else {
            setError(true);
        }
    };

    useEffect(() => {
        if (!showResend) {
            timer = setInterval(() => {
                setRemainTime((time) => time - 1);
            }, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [showResend]);

    useEffect(() => {
        if (remainTime === 0) {
            clearInterval(timer);
            setResend(true);
        }
    }, [remainTime]);

    useEffect(() => {
        const forgetPasswordState = window.location.search;
        if (forgetPasswordState) {
            setForgetPassword(true);
        }
    }, [forgetPassword]);

    const resendCode = () => {
        request
            .post(
                "/api/users/resendActivationCode.json",
                JSON.stringify({
                    mobile: state.phoneNumber,
                }),
            )
            .then((res) => {
                setLoading(false);
                if (res?.data.state) {
                    setResend(false);
                } else {
                    setErrorRecived(res?.data.message);
                }
            })
            .catch((error) => {
                setLoading(false);
                setErrorRecived("لطفا چند لحظه دیگر مجدد تلاش کنید");
            });
    };

    return (
        <AuthMain
            title="تایید شماره همراه"
            buttonText="تایید"
            onClickButton={forgetPassword ? recoverPassword : sendOTP}
            otp={true}
        >
            <div className={styles.otp}>
                <p className={styles.otp_text}>
                    شماره شش رقمی ارسال شده به شماره{" "}
                    <span className={styles.otp_cellphone}>{toPersian(state.phoneNumber)}</span> را وارد کنید{" "}
                    {!showResend && `(${toPersian(remainTime)} ثانیه) `}
                </p>
                {showResend && (
                    <div className={styles.otp_resend} onClick={resendCode}>
                        <span className={styles.otp_resend__item}>ارسال مجدد رمز یک بار مصرف</span>
                    </div>
                )}
                {forgetPassword ? (
                    <div className={styles.otp}>
                        <Input
                            type="text"
                            placeholder="رمز یکبار مصرف"
                            onInput={(e) => setOTP(e.target.value)}
                            maxLength="5"
                            icon="icon-locked"
                            error={error && !OTP.length && "رمز یکبار مصرف ارسالی را وارد کنید"}
                        />

                        <Input
                            type="password"
                            placeholder="رمز عبور جدید"
                            onInput={(e) => setPassword(e.target.value)}
                            icon="icon-locked"
                            error={
                                error && !password.length
                                    ? "رمز عبور خود را وارد کنید"
                                    : error && password.length < 6
                                    ? "رمز عبور نباید کمتر از 6 رقم باشد"
                                    : ""
                            }
                        />
                    </div>
                ) : (
                    <OTPInput value={OTP} onInput={(e) => setOTP(e.target.value)} />
                )}
            </div>
        </AuthMain>
    );
};
export default Login;
